module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_7016.05e0da2f.png";